/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import styles from './Dashboard.module.css';
import { Section, Header, AlertsMap } from 'components';
import { ToastMessage } from 'containers';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { GaugeWidget } from './MetricWidget';
import { GaugeType, GaugeData, GeoLocationPoint } from 'model';

type DashboardProps = {
  fetchDashboardMetrics: (userId: string) => void;
  fetchDashboardAlerts: (userId: string) => void;
  userId?: string | null;
  gauges: Map<GaugeType, GaugeData>;
  isLoading: boolean;
  geoLocationPoints: GeoLocationPoint<Location>[];
}

export const Dashboard: React.FC<DashboardProps> = React.memo(({
  fetchDashboardMetrics,
  fetchDashboardAlerts,
  userId,
  isLoading,
  gauges,
  geoLocationPoints,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (userId) {
      fetchDashboardMetrics(userId);
      fetchDashboardAlerts(userId);
    }
  }, [userId]);

  return (
    <Section>
      <ToastMessage /> 
      <Header className={styles.header} noBackground>
        <Col xs="12" className="pl-0 pr-0"><h2>{t('dashboard')}</h2></Col>
      </Header>
      <Row>
        <Col xs="12" className="pl-0 pr-0">
          <Row>
            <Col xs="6" md="3" className={styles.metricContainer}>
              <GaugeWidget title={t('Critical Alerts')} isLoading={isLoading} data={gauges.get(GaugeType.CRITICAL)} />
            </Col>
            <Col xs="6" md="3" className={styles.metricContainer}>
              <GaugeWidget title={t('Warning Alerts')} isLoading={isLoading} data={gauges.get(GaugeType.WARNING)} />
            </Col>
            <Col xs="6" md="3" className={styles.metricContainer}>
              <GaugeWidget title={t('Healthy Devices')} isLoading={isLoading} data={gauges.get(GaugeType.HEALTHY)} />
            </Col>
            <Col xs="6" md="3" className={styles.metricContainer}>
              <GaugeWidget title={t('Devices Offline')} isLoading={isLoading} data={gauges.get(GaugeType.OFFLINE)} />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="pl-0 pr-0">
          <AlertsMap geoLocationPoints={geoLocationPoints} />
        </Col>
      </Row>
    </Section>
  );
});

export default Dashboard;